import router from '@/router'
import axios from '@/plugins/axios'
import { logout as websdkLogout } from '@/utils/websdk'

const moduleUser = {
  namespaced: true,
  state: {
    NICK_NAME: '' || localStorage.getItem('nickname'), // 用户昵称
    NAME_CHILD: true, // 玩家起名
  },
  mutations: {
    SET_NICK_NAME: (state, params) => {
      state.NICK_NAME = params
      localStorage.setItem('nickname', params)
    },
    REMOVE_NICK_NAME: state => {
      state.NICK_NAME = ''
      localStorage.removeItem('nickname')
    },
    SET_NAME_CHILD: (state, params) => {
      state.NAME_CHILD = params
    },
  },
  actions: {
    getUserInfo(obj = { commit }, a, b) {
      const { commit } = obj
      return new Promise((resolve, reject) => {
        axios
          .get('/user/info')
          .then(v => {
            if (v.uid && v.nickname) {
              commit('SET_NICK_NAME', v.nickname)
              commit('SET_NAME_CHILD', true)
            } else {
              // 创建了角色的账号有，并且没有昵称
              commit('SET_NAME_CHILD', false)
            }
            resolve(v)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    logout({ commit }) {
      console.log('logout..')
      return new Promise((resolve, reject) => {
        axios
          .post('/user/logout')
          .then(v => {
            console.log('logout res'.v)
            localStorage.removeItem('token')
            commit('REMOVE_NICK_NAME')
            websdkLogout()
            resolve(v)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
  },
  getters: {},
}

export default moduleUser
